import { runNativeMigration } from "./nativeMigration.ts";

/**
 * main.tsx'te ilk import: ES modülleri sırayla değerlendirildiği için taşıma,
 * diğer modüller depoyu okumadan önce biter. Eski adrese yönlendirme
 * başladıysa arayüz hiç çizilmez.
 */
export const redirectingForMigration = runNativeMigration();
